<script lang="ts">
import type { PaymentMethod } from '@/types'
import { sentenceCase } from 'change-case'
import { type PropType, defineComponent } from 'vue'

/**
 * A credit/debit card icon component that displays the appropriate card brand icon based on the provided brand prop.
 */
export default defineComponent({
  props: {
    brand: {
      type: String as PropType<PaymentMethod['brand']>,
      required: true,
    },
  },
  setup() {
    return {
      sentenceCase,
    }
  },
})
</script>

<template>
  <AppIcon :icon="sentenceCase(brand)" size="md" class="h-auto" />
</template>
